import {useI18n} from 'i18n/I18nContext'
import {Balance} from 'organization/Earning/EarningProvider'
import React from 'react'
import {formatUserDate} from 'utils/lib/date'

export const ListBalance = (props: {balance: Balance; index: number}) => {
  const {t} = useI18n()
  const {balance, index} = props

  return (
    <tr key={index}>
      <td>{balance.id}</td>
      <td>{formatUserDate(balance.created_at)}</td>
      <td>
        <span className={'status__tag bg-green'}>
          <span>{t('orgAffiliate.balanceIncome')}</span>
        </span>
      </td>
      <td>{balance.ticket_tier_name ?? '—'}</td>
      <td>{balance.description}</td>
      <td>{balance.price.toFixed(2)} €</td>
      <td>{balance.application_fee.toFixed(2)} €</td>
      <td>{(balance.price - balance.application_fee).toFixed(2)} €</td>
      <td>
        {balance.refunded ? (
          <span className={'status__tag bg-warn'}>
            <span>{t('orgEarnings.statusRefunded')}</span>
          </span>
        ) : balance.is_paid ? (
          <span className={'status__tag bg-green'}>
            <span>{t('orgEarnings.statusPaidOut')}</span>
          </span>
        ) : balance.is_holded ? (
          <span className={'status__tag warning-bg'}>
            <span>{t('orgEarnings.statusHeld')}</span>
          </span>
        ) : (
          <span className={'status__tag warning-bg'}>
            <span>{t('orgEarnings.statusPayoutDue')}</span>
          </span>
        )}
      </td>
    </tr>
  )
}
